// extracted by mini-css-extract-plugin
export default {"container":"MI-z","header":"NI-z","details":"OI-z","link":"PI-z"};